import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
// @material-ui/core components
import FilterStyles from 'assets/jss/AdsFilter';
import Select from '@material-ui/core/Select/Select';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import withStyles from '@material-ui/core/styles/withStyles';

function objectsAreEqual(a, b) {
  const aProps = Object.getOwnPropertyNames(a);
  const bProps = Object.getOwnPropertyNames(b);

  if (aProps.length !== bProps.length) {
    return false;
  }

  return !aProps.some(prop => a[prop].toString() !== b[prop].toString());
}

const ReadableDate = ({ years, months, days, hours, minutes, seconds }) =>
  moment()
    .add({ seconds, minutes, hours, days, months, years })
    .fromNow(true);

/**
 * @description
 * Stateless component
 *
 * @param {Object} props - Component props.
 */
const DurationSelect = props => {
  const { classes, selectedDuration, change, durations, selectAll, t } = props;
  return (
    <div>
      <Select
        data-cy="adsFilterDurationSelect"
        id="select-duration"
        className={classes.categoryDD}
        MenuProps={{
          className: classes.selectMenu,
        }}
        classes={{
          select: classes.select,
        }}
        value={
          selectedDuration
            ? // Since the durations are objects,
              // selectedDuration can be a different object
              // but still having the same values,
              // so we need to compare the values
              // to know the selected duration
              durations.find(value => objectsAreEqual(value, selectedDuration))
            : 'all'
        }
        onChange={e =>
          change({
            duration: e.target.value === 'all' ? undefined : e.target.value,
          })
        }
        inputProps={{
          name: 'selectDuration',
          id: 'selectDuration',
        }}
      >
        {selectAll && (
          <MenuItem
            key="select-duration-all"
            classes={{
              root: classes.selectMenuItem,
              selected: classes.selectMenuItemSelected,
            }}
            value="all"
          >
            {t('common.all')}
          </MenuItem>
        )}
        {durations.map((duration, key) => (
          <MenuItem
            id={`select-durations-${key}`}
            key={`select-durations-${ReadableDate(duration)}`}
            classes={{
              root: classes.selectMenuItem,
              selected: classes.selectMenuItemSelected,
            }}
            value={duration}
          >
            {ReadableDate(duration)}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};

/**
 * DurationSelect PropTypes
 * @param classes - prop styles received from withStyles
 * @param selectedDuration - prop to know selected duration
 * @param selectAll - prop to know if can select all durations
 * @param durations - prop durations received from parent
 * @param t - prop from HOC with string translations
 * @callback change - callback called when selected province
 * or municipality change
 */

DurationSelect.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  selectedDuration: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  durations: PropTypes.instanceOf(Array).isRequired,
  change: PropTypes.func.isRequired,
  selectAll: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

DurationSelect.defaultProps = {
  selectedDuration: undefined,
  selectAll: false,
};

export default withTranslation()(withStyles(FilterStyles)(DurationSelect));
